import React from 'react';
import { Paper, Typography, Grid } from '@mui/material';
import { PaymentTotal, formatCurrency } from './PaymentTypes';

interface PaymentTotalSummaryProps {
  paymentTotal: PaymentTotal | null;
}

export const PaymentTotalSummary: React.FC<PaymentTotalSummaryProps> = ({ paymentTotal }) => {
  if (!paymentTotal) {
    return null;
  }

  return (
    <Paper sx={{ mt: 2, mb: 3, p: 2 }}>
      <Typography variant="h6" gutterBottom>
        合計金額内訳
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={6} md={1.7}>
          <Typography variant="body2" color="text.secondary">
            合計報酬額
          </Typography>
          <Typography variant="h6">{formatCurrency(paymentTotal.totalAmountWithoutTax)}</Typography>
        </Grid>
        <Grid item xs={6} md={1.7}>
          <Typography variant="body2" color="text.secondary">
            合計今回報酬額
          </Typography>
          <Typography variant="h6">{formatCurrency(paymentTotal.totalCurrentRewardAmount)}</Typography>
        </Grid>
        <Grid item xs={6} md={1.7}>
          <Typography variant="body2" color="text.secondary">
            合計繰越金額
          </Typography>
          <Typography variant="h6">{formatCurrency(paymentTotal.totalCarryoverAmount)}</Typography>
        </Grid>
        <Grid item xs={6} md={1.7}>
          <Typography variant="body2" color="text.secondary">
            合計支払い事務手数料
          </Typography>
          <Typography variant="h6">{formatCurrency(paymentTotal.totalAdministrativeFee)}</Typography>
        </Grid>
        <Grid item xs={6} md={1.7}>
          <Typography variant="body2" color="text.secondary">
            合計支払額
          </Typography>
          <Typography variant="h6">{formatCurrency(paymentTotal.totalPaymentAmount)}</Typography>
        </Grid>
        <Grid item xs={6} md={1.7}>
          <Typography variant="body2" color="text.secondary">
            合計保留額
          </Typography>
          <Typography variant="h6">{formatCurrency(paymentTotal.totalPendingAmount)}</Typography>
        </Grid>
        <Grid item xs={6} md={1.7}>
          <Typography variant="body2" color="text.secondary">
            合計失効額
          </Typography>
          <Typography variant="h6">{formatCurrency(paymentTotal.totalForfeitedAmount)}</Typography>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default PaymentTotalSummary;
